import { useEffect } from 'react';
import { redirect404 } from '../../router';
import { AxiosError } from 'axios';
import { History } from 'history';

type TF = (error: AxiosError | null, history: History) => void;

export const useRedirect404: TF = (error, history) => {
  useEffect(() => {
    if (error && error.response && error.response.status === 404) {
      redirect404(history);
    }

    if (error && error.response && error.response.status === 400) {
      history.replace({ ...history.location, state: { is400: true } });
    }
  }, [error, history]);
};
